import React, { Component } from "react";
import clsx from "clsx";

class QuestionCrumbs extends Component {
  render() {
    const { questionsList, currentQuestion } = this.props;
    return (
      <React.Fragment>
        <p>Questions</p>
        <ul>
          {questionsList.map((question, index) => {
            return (
              <li
                className={clsx("question-crumb", {
                  "selected-question": currentQuestion === index + 1,
                  "disabled-question": currentQuestion < index + 1,
                })}
                key={question.id}
              >
                {index + 1}
              </li>
            );
          })}
        </ul>
      </React.Fragment>
    );
  }
}

export default QuestionCrumbs;



// WEBPACK FOOTER //
// ./src/_components/QuestionCrumbs/index.jsx